import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";

import Template from "../../components/Location/TranslationTemplate/TranslationTemplate";
import locations from "../../data/locations";

const TranslationTemplate = ({ match }) => {
  const language = match.params.type;
  const history = useHistory();

  const location = match.params.location;
  const [show, setShow] = useState(false);

  const findLocation = (loc) => {
    return (
      loc.split(/[-' ]/).join(" ").toLowerCase() ===
      location.split(/[-' ]/).join(" ").toLowerCase()
    );
  };
  const getLocation = locations.find(findLocation);

  useEffect(() => {
    if (getLocation) setShow(true);
    else history.replace("/404");
  }, [getLocation, history]);

  return (
    <div>{show && <Template language={language} location={location} />}</div>
  );
};

export default TranslationTemplate;
